<template>
    <div class="col-12" v-if="comunicado">
        <div class="alert alert-info rounded">
            <div class="d-flex flex-grow-1 align-items-baseline">
                📢✨
                <strong class="mr-auto"> Temos boas Noticias! 😁🤩</strong>
            </div>
            <h5 class="mb-3">O sistema acabou de receber uma nova atualização.</h5>
            <!-- <p>{{ comunicado.title }}</p> -->
            <a class="btn btn-success mb-0" @click="$bvModal.show('post-home-modal')">
                <span class="d-flex align-items-center">
                    <i class="mdi mdi-star mdi-18px mr-2"></i>
                    Confira as novidades clicando aqui
                </span>
            </a>
            <router-link class="btn btn-primary mb-0" to="/dashboard/admin/central/home?page=update">
                <span class="d-flex align-items-center">
                    <i class="mdi mdi-update mdi-18px mr-2"></i>
                    Veja as ultimas as atualizações</span>
            </router-link>
            <b-modal :hide-footer="true" centered size="xl" id="post-home-modal" :title="comunicado.title">
                <load v-if="loadingPost" mode="table" />
                <div v-else class="row">
                    <div class="col-12 my-4" style="overflow: auto; display: block; max-height: 600px"
                        v-html="comunicado.text">
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn-success" @click="markRead">
                            <i class="mdi mdi-check-circle"></i> Marcar como lida
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>    
<script>
export default {
    name: 'PostAtualizacao',
    data() {
        return {
            loadingPost: false,
            comunicado: null
        }
    },
    mounted() { this.getComunicado() },
    methods: {
        markRead() {
            this.loadingPost = true;
            axios
                .get(`api/dashboard/post/read/${this.comunicado.id}`)
                .then((response) => {
                    this.$bvModal.hide("post-home-modal");
                    this.comunicado = null;
                })
                .finally(() => {
                    this.loadingPost = false;
                });
        },
        getComunicado() {
            axios.get("api/dashboard/post/last")
            .then((response) => {
                this.comunicado = response.data;
            });
        },
    }
}  
</script>